import { createContext } from "react";

export const AudioContext = createContext(null)